import { cx } from '../../../api';

export const clone = (zone) => {
	const clone = cx.meta.clone(zone);
	if (clone.style != null) clone.style = {...zone.style};
	return clone;
};